import { ProductInterestRatesSchema } from '@kvika/audur-api-types'
import { Spacing } from '@kvika/audur-theme'

import { AudurContentPageSlicesInteresttableFields, Maybe } from '../../../prismic/prismicTypes'

import InterestTableRow from './InterestTableRow'

type Props = {
	tableFields: Maybe<Array<AudurContentPageSlicesInteresttableFields>>
	historicalInterestRates: Array<ProductInterestRatesSchema>
}

const InterestTable = ({ tableFields, historicalInterestRates }: Props) => {
	return (
		<div style={{ overflowX: 'auto', marginTop: Spacing.Large }}>
			{tableFields?.map((field, index) => {
				const productHistoricalInterestRates = historicalInterestRates.find(
					(rates) => rates.type === field.bank_account_type_slug && rates.term === field.bank_account_term_slug
				)
				return (
					<InterestTableRow row={field} key={index} productHistoricalInterestRates={productHistoricalInterestRates} />
				)
			})}
		</div>
	)
}

export default InterestTable
